module.exports = "/_next/static/images/7a141f2490729ab935684b4a1f284331-people-working-together@md-1x.jpg";